export const SITE = {
  brand: "Net Design",
  tagline: "Websites that win local customers",
  contact: {
    email: "timothyseibel86@gmail.com",
    phone: "(347) 217-2974",
    city: "Serving local businesses nationwide",
  },
  scheduleUrl: "https://calendar.app.google/F6iRjUzWQwRfjqu5A",
  ctas: {
    primary: "Get My Free Website Demo",
    secondary: "Schedule a Consultation",
  },
};

export const INDUSTRIES = [
  { key: "plumbers", label: "Plumbers" },
  { key: "electricians", label: "Electricians" },
  { key: "landscapers", label: "Landscapers" },
  { key: "hvac", label: "HVAC Contractors" },
  { key: "roofers", label: "Roofers" },
  { key: "cleaning", label: "Cleaning Companies" },
  { key: "auto", label: "Auto Repair Shops" },
  { key: "handymen", label: "Handymen" },
  { key: "painters", label: "Painters" },
  { key: "retail", label: "Small Retail Stores" },
  { key: "restaurants", label: "Restaurants" },
  { key: "contractors", label: "Independent Contractors" },
];

export const TRUST_BADGES = [
  "Fast Turnaround",
  "Mobile Friendly",
  "SEO Ready",
  "Local Business Specialist",
  "Free Custom Demo",
  "No Commitment",
];

export const IMAGES = {
  hero_mockup:
    "https://images.unsplash.com/photo-1634084462412-b54873c0a56d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB3ZWJzaXRlJTIwbW9ja3VwfGVufDB8fHx8MTc4MTI3Mzk1NXww&ixlib=rb-4.1.0&q=85",
  industry_plumber:
    "https://images.pexels.com/photos/33388390/pexels-photo-33388390.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  industry_restaurant:
    "https://images.unsplash.com/photo-1556745750-68295fefafc5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxyZXN0YXVyYW50JTIwb3duZXJ8ZW58MHx8fHwxNzgxMjczOTYwfDA&ixlib=rb-4.1.0&q=85",
  industry_landscaper:
    "https://images.unsplash.com/photo-1734303023491-db8037a21f09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxsYW5kc2NhcGVyJTIwd29ya2luZ3xlbnwwfHx8fDE3ODEyNzM5NjB8MA&ixlib=rb-4.1.0&q=85",
  industry_retail:
    "https://images.unsplash.com/photo-1753161029695-f1d1e6881257?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxzbWFsbCUyMGJ1c2luZXNzJTIwb3duZXIlMjB0YWJsZXR8ZW58MHx8fHwxNzgxMjczOTU0fDA&ixlib=rb-4.1.0&q=85",
  portfolio_mobile:
    "https://images.unsplash.com/photo-1697292859724-0d2501966448?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB3ZWJzaXRlJTIwbW9ja3VwfGVufDB8fHx8MTc4MTI3Mzk1NXww&ixlib=rb-4.1.0&q=85",
  industry_electrician:
    "https://images.unsplash.com/photo-1621905251918-48416bd8575a?auto=format&fit=crop&w=1200&q=80",
  industry_hvac:
    "https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1200&q=80",
  industry_painter:
    "https://images.unsplash.com/photo-1562259949-e8e7689d7828?auto=format&fit=crop&w=1200&q=80",
  industry_auto:
    "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?auto=format&fit=crop&w=1200&q=80",
};

export const SERVICES = [
  {
    title: "Custom Design",
    desc: "Hand-crafted websites built around your business, your services, and the customers you want to win.",
    icon: "PenTool",
  },
  {
    title: "Mobile Friendly",
    desc: "Over 60% of local searches happen on a phone. Your site will look sharp on every screen.",
    icon: "Smartphone",
  },
  {
    title: "SEO Ready",
    desc: "Built to show up on Google when neighbors search for the services you offer.",
    icon: "Search",
  },
  {
    title: "Fast Hosting",
    desc: "Lightning-fast load times, secure HTTPS, and rock-solid uptime included.",
    icon: "Zap",
  },
  {
    title: "Lead Capture",
    desc: "Contact forms, click-to-call, and instant quote requests so customers reach you in one tap.",
    icon: "MessageSquare",
  },
  {
    title: "Google Profile Sync",
    desc: "Your website, Google Business Profile, and reviews work together to dominate local results.",
    icon: "MapPin",
  },
];

export const PROCESS = [
  {
    step: "01",
    title: "Free Demo",
    desc: "Send us a few details about your business. Within 2–3 business days we send you a real, working demo of your future website. No payment, no commitment.",
  },
  {
    step: "02",
    title: "Review & Refine",
    desc: "Love it? We polish the details together — your photos, your colors, your services. Want changes? Tell us. Want to walk away? No hard feelings.",
  },
  {
    step: "03",
    title: "Launch & Grow",
    desc: "We launch your site, connect it to Google, and hand you the keys. New customers start finding you online — usually within the first week.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I had a Facebook page and a Google listing for 6 years. The week our website went live we booked 11 new jobs. I should have done this sooner.",
    name: "Marcus R.",
    role: "Owner, Marcus Plumbing & Drains",
  },
  {
    quote:
      "They sent me a full demo before I paid a dollar. That made the decision easy. The site looks better than companies 5x my size.",
    name: "Linda T.",
    role: "Owner, Sweetgrass Cleaning Co.",
  },
  {
    quote:
      "Affordable, fast, and they actually picked up the phone. My calendar has been full ever since.",
    name: "Diego A.",
    role: "Founder, AllSeason HVAC",
  },
];

export const FAQS = [
  {
    q: "How much does a website cost?",
    a: "Our local business packages start at a flat, affordable price designed for owner-operators and small teams. You'll see exact pricing the moment we share your free demo — no surprise quotes.",
  },
  {
    q: "What does the free demo include?",
    a: "A real, working preview of your future website — your branding, your services, your photos, your service area. If you don't love it, you owe us nothing.",
  },
  {
    q: "How long does it take to launch?",
    a: "Most local business sites go live within 7–14 days from approval. Rush launches are possible when you need to win a busy season.",
  },
  {
    q: "Do I need to write content myself?",
    a: "No. We write your homepage, service pages, and calls-to-action for you based on a short conversation about your business.",
  },
  {
    q: "Will my site work on Google?",
    a: "Yes. Every site we build is SEO-ready, mobile-optimized, and synced with your Google Business Profile so neighbors searching nearby can find you.",
  },
  {
    q: "What if I already have a Facebook page or Google listing?",
    a: "Even better. We connect them all so your website, social profiles, and Google listing point customers in the same direction.",
  },
];
